import {ShowMessageBox} from "react-vmessagebox";
import {Vec2Simple} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {useState} from "react";
import React from "react";
import {Column, Row, Text, Select, Button, TextArea} from "react-vcomponents";
import {DialogStyle} from "../../../../../Utils/UI/GlobalStyles.js";
import {ScrollView} from "react-vscrollview";
import {AssertUnreachable} from "web-vcore";
import {SpinnerForPercent} from "../../../../../Utils/ReactComponents/SpinnerForPercent.js";
import {Vec2Editor} from "../../../../../Utils/ReactComponents/VecEditor.js";
import {Vec2} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {GetEntries} from "js-vextensions";

export enum PointsTransformType {
	scale = "scale",
	translate = "translate",
}

function ApplyPointsTransform(points: Vec2Simple[], transform: PointsTransformType, extras: {scaleFactor?: number, translateAmount?: Vec2}) {
	if (transform == PointsTransformType.scale) {
		const scaleFactor = extras.scaleFactor ?? 1;
		return points.map(point=>{
			return [point[0] * scaleFactor, point[1] * scaleFactor];
		});
	}
	if (transform == PointsTransformType.translate) {
		const amount = extras.translateAmount ?? new Vec2(0, 0);
		return points.map(point=>{
			return [point[0] + amount.x, point[1] + amount.y];
		});
	}
	AssertUnreachable(transform, `Unknown transform type: ${transform}`);
}

export function ShowPointsTransformDialog(origPoints: Vec2Simple[]) {
	ShowMessageBox({
		title: "Points transform tools", cancelButton: true,
		message: ()=><PointsTransformToolsUI origPoints={origPoints}/>,
	});
}

const PointsTransformToolsUI = ({origPoints}: {origPoints: Vec2Simple[]})=>{
	const [transform, setTransform] = useState(PointsTransformType.scale);
	const leftText = JSON.stringify(origPoints);
	const [scaleFactor, setScaleFactor] = useState(1);
	const [translateAmount, setTranslateAmount] = useState(new Vec2(0, 0));
	const transformedPoints = ApplyPointsTransform(origPoints, transform, {scaleFactor, translateAmount});
	const rightText = JSON.stringify(transformedPoints);

	return (
		<Column style={DialogStyle({width: 800})}>
			<Row center mb={5}>
				<Text mr={5}>Transform:</Text>
				<Select displayType="button bar" options={GetEntries(PointsTransformType, "ui")}
					value={transform} onChange={val=>setTransform(val)}/>
				<Row ml="auto">
					{transform == PointsTransformType.scale && <>
						<Text>Scale factor:</Text>
						<SpinnerForPercent ml={5} max={Infinity} step={10} value={scaleFactor} onChange={val=>setScaleFactor(val)}/>
					</>}
					{transform == PointsTransformType.translate && <>
						<Text>Translate amount:</Text>
						<Vec2Editor ml={5} value={translateAmount} onChange={val=>setTranslateAmount(val)}/>
					</>}
				</Row>
			</Row>
			<Row style={{flex: 1, gap: 10}}>
				<ScrollView style={{flex: 1}}>
					<TextArea style={{border: "1px solid black"}} autoSize={true} editable={false} {...{minRows: 5} as any} value={leftText}/>
				</ScrollView>
				<ScrollView style={{flex: 1}}>
					<TextArea style={{border: "1px solid black"}} autoSize={true} editable={false} {...{minRows: 5} as any} value={rightText}/>
				</ScrollView>
			</Row>
		</Column>
	);
};